module.exports = __webpack_public_path__ + "static/media/personality3.20fadaaf.jpeg";